// Mirrors the format checks in PhoenixCapital.Core.Common.EmailAddressHelper.
// Server validation is authoritative; this gives the UI an immediate
// inline error so users see the problem before submitting.

export function isValidEmail(input: string | null | undefined): boolean {
  if (input == null) return false;
  const s = input;
  if (s.trim().length === 0) return false;
  if (s.includes("\r") || s.includes("\n")) return false;
  if (!s.includes("@")) return false;
  if (s.includes("..")) return false;

  const atIndex = s.indexOf("@");
  if (atIndex === 0 || atIndex === s.length - 1) return false;
  if (atIndex !== s.lastIndexOf("@")) return false;

  const [local, domain] = s.split("@");
  if (local.trim().length === 0 || domain.trim().length === 0) return false;

  // Local part — permissive but rejects bare whitespace / backslash / leading dot.
  if (/\s/.test(local[0])) return false;
  if (local.startsWith(".")) return false;
  const quoteCount = (local.match(/"/g) ?? []).length;
  if (quoteCount === 1) return false;
  if (quoteCount === 0) {
    if (/\s/.test(local)) return false;
    if (local.includes("\\")) return false;
  }

  // Domain part — must contain a dot (sub-domain) or be a bracketed IP literal.
  if (/\s/.test(domain)) return false;
  if (domain.startsWith(".") || domain.endsWith(".")) return false;
  if (domain.includes("(") || domain.includes(")")) return false;

  const isSubDomain = domain.includes(".");
  const isIpLiteral =
    domain.startsWith("[") && domain.endsWith("]") && domain.length > 2;
  if (!isSubDomain && !isIpLiteral) return false;

  return true;
}

export function emailFieldError(
  input: string | null | undefined,
  { required }: { required: boolean } = { required: false }
): string | undefined {
  const trimmed = (input ?? "").trim();
  if (trimmed.length === 0) {
    return required ? "Email is required." : undefined;
  }
  return isValidEmail(trimmed) ? undefined : "Enter a valid email address.";
}
